<template>
  <div
    class="tab-pane"
    :class="{ active: user_type == '4' }"
    id="admit_students_tab"
    role="tabpanel"
    aria-labelledby="admit-students-tab"
  >
    <div class="form-group row">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <label for="name" class="form-label"
          >Dzongkhag: <span class="text-danger">*</span></label
        >
        <select
          v-model="dzongkhag_id"
          class="form-control"
          aria-label="dzongkhag_id"
          :class="{ 'is-invalid': is_invalid_dzong }"
          id="dzongkhag_id"
          @change="getOrganization(), remove_err('dzongkhag_id')"
        >
          <option value="">---SELECT---</option>
          <option v-for="(item, i) in dzongkhags" :key="i" :value="item.id">{{
            item.name
          }}</option>
        </select>
        <span class="text-danger" v-if="is_invalid_dzong">{{ error }}</span>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <label for="name" class="form-label"
          >School: <span class="text-danger">*</span></label
        >
        <select
            v-model="school_id"
            class="form-control"
            aria-label="school_id"
            :class="{ 'is-invalid': is_invalid_school }"
            id="school_id"
            @change="getStudents(), remove_err('school_id')"
        >
          <option value="">---SELECT---</option>
          <option v-for="(item, i) in schools" :key="i" :value="item.id">{{
            item.organization
          }}</option>
        </select>
        <span class="text-danger" v-if="is_invalid_school">{{
          error_school
        }}</span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <label class="card-header text-center"
            ><strong>Admission to Public Schools</strong></label
          >
          <table class="table table-bordered table-striped" >
            <thead>
              <tr>
                <th></th>
                <th colspan="4" class="text-center">Student Information</th>
                <th colspan="6" class="text-center">Student Placement</th>
              </tr>
              <tr>
                <th>S.No</th>
                <th>Name of Student</th>
                <th>Index Number</th>
                <th>Dzongkhag</th>
                <th>School</th>
                <th>Dzongkhag</th>
                <th>School</th>
                <th>Class</th>
                <th>Stream</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in student_information" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.std_indexno }}</td>
                <td>{{ item.dzongkhag }}</td>
                <td>{{ item.organization }}</td>
                <td>
                  {{ dzongkhag }}
                </td>
                <td>
                  {{ organization }}
                </td>
                <td>XI</td>
                <td>
                  <select
                    v-model="student_information[index].stream"
                    class="form-control form-control-sm"
                    aria-label="stream"
                    :id="'stream_' + index"
                  >
                    <option value="">---SELECT---</option>
                    <option
                      v-for="(item3, i2) in streams"
                      :key="i2"
                      :value="item3.id"
                      >{{ item3.name }}</option
                    >
                  </select>
                </td>
                <td>
                  <select
                    v-model="student_information[index].remarks"
                    class="form-control form-control-sm"
                    aria-label="status"
                  >
                    <option value="">---SELECT---</option>
                    <option value="admitted">Admitted</option>
                    <option value="not_admitted">Not Admitted</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-right mb-2 mr-2">
            <button type="button" class="btn btn-primary" @click="submit()">
              <i class="fas fa-paper-plane"></i> Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_type: "",
      dzongkhags: [],
      dzongkhag_id: "",
      schools: [],
      school_id: "",
      streams: [
        { name: "Science", id: "Science" },
        { name: "Arts", id: "Arts" },
        { name: "Commerce", id: "Commerce" },
        { name: "Rigzhung", id: "Rigzhung" },
      ],
      student_information: [],
      remarks: "",
      is_invalid_dzong: false,
      is_invalid_school: false,
      error: "",
      error_school: "",
      dzongkhag: "",
      dzong_id: "",
      organization: "",
      org_id: "",
      dt:'',
    };
  },
  methods: {
    remove_err(fieldid) {
      if ($("#" + fieldid).val() != "") {
        $("#" + fieldid).removeClass("is-invalid");
        this.error = "";
        this.error_school = "";
      }
    },
    getDzongkhags(cluster) {
      axios.get("dzongkhags/getDzongkhagsbyCluster/" + cluster)
        .then((response) => {
          this.dzongkhags = response.data;
        })
        .catch((error) => console.log(error));
    },
    getOrganization() {
      this.schools = [];
      axios.get("school/getPublicOrganization/" + this.dzongkhag_id)
        .then((response) => {
            this.schools = response.data;
        })
        .catch((error) => console.log(error));
    },
    getStudents() {
      axios
        .get("admissions/getStudentsforpublic/" + this.school_id)
        .then((response) => {
          this.student_information = response.data;
        })
        .catch((error) => console.log(error));
    },
    getOrganizationById(organization_id) {
      axios.get("school/getOrganizationById/" + organization_id)
        .then((response) => {
          let data = response.data;
          this.org_id = data[0].id;
          this.organization = data[0].organization;
          this.dzong_id = data[0].dzongkhag_id;
          this.dzongkhag = data[0].dzongkhag;
        })
        .catch((error) => console.log(error));
    },
    submit() {
      if ($("#dzongkhag_id").val() == "" && $("#school_id").val() == "") {
        this.is_invalid_dzong = true;
        this.is_invalid_school = true;
        this.error = "This field is required.";
        this.error_school = "This field is required.";
      } else if ($("#dzongkhag_id").val() == "") {
        this.is_invalid_dzong = true;
        this.error = "This field is required.";
      } else if ($("#school_id").val() == "") {
        this.is_invalid_school = true;
        this.error_school = "This field is required.";
      } else {
        let filterData = this.student_information.filter(
          (item) => item.remarks == "admitted"
        );
        axios.post("admissions/saveAdmittedStudentsofCluster", {
            data: filterData,
            dzong_id: this.dzong_id,
            org_id: this.org_id,
          }).then((res) => {
            if (res.data.error) {
              Swal.fire({
                icon: "warning",
                text: res.data.error,
              });
            } else {
              Toast.fire({
                icon: "success",
                title: "Detail submitted successfully",
              });
              this.$router.go(this.$router.currentRoute);
            }
          })
          .catch((error) => console.log(error));
      }
    },
  },
  mounted() {
    axios.get("getSessionDetail").then((response) => {
      let data = response.data.data;
      this.user_type = data["role"];
      this.getDzongkhags(data["cluster_id"]);
      this.getOrganizationById(data["organization_id"]);
    });
  },
};
</script>
